import { connect, ConnectedProps } from 'react-redux'
import AccordionFound from 'components/accordion/AccordionFound'
import { setAccordionIsLoaded } from 'redux/actions'
import { RootState, AppDispatch } from 'redux/store'

const mapStateToProps = (state: RootState): { expandedNodeTitle: RootState['accordion']['expandedNodeTitle'], isAccordionLoaded: RootState['placeholders']['isAccordionLoaded'] } => ({
  expandedNodeTitle: state.accordion.expandedNodeTitle,
  isAccordionLoaded: state.placeholders.isAccordionLoaded
})

const mapDispatchToProps = (dispatch: AppDispatch): { setAccordionIsLoaded: (isLoaded: boolean) => ReturnType<AppDispatch> } => ({
  setAccordionIsLoaded: (isLoaded: boolean) => dispatch(setAccordionIsLoaded(isLoaded))
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export type AccordionFoundContainerProps = ConnectedProps<typeof connector>
export default connector(AccordionFound)
